export default __webpack_public_path__ + "static/media/bg-retangles-mid.992e7148.png";